import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { BaseSafeFormView, BaseView } from '@/components/base'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'
import { KemCard } from '@/components/KemCard'
import {
  kemCardStylesList,
  KemCardStyleItem,
} from '@/constants/kemCardStylesList'
import { useKemCardStore } from '@/store/useKemCardStore'
import { useTranslation } from 'react-i18next'

export const KemCardChooseStyleScreen: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()
  const { setKemCardStyleKey } = useKemCardStore()

  const isChangeCardStyle = location.state?.isChangeCardStyle

  const handleSelectCardStyle = (item: KemCardStyleItem) => {
    setKemCardStyleKey(item.key)

    setTimeout(
      () =>
        isChangeCardStyle
          ? navigate(-1)
          : navigate('/kem-card/info-confirmation'),
      200,
    )
  }

  return (
    <BaseSafeFormView
      flex={1}
      bgColor="background.screen"
      className="h-full"
      style={{ padding: '0 12px' }}
    >
      <StickyHeaderNavigation
        title={t('translation:kemCard.chooseCardStyle')}
        onBackPress={() => navigate(-1)}
      />

      <BaseView
        style={{
          padding: '19px 0',
          gap: '24px',
          alignItems: 'center',
          overflowY: 'auto',
          flex: 1,
        }}
      >
        {kemCardStylesList.map((item) => (
          <KemCard
            key={item.id}
            kemCardStyleItem={item}
            onPress={handleSelectCardStyle}
            kemCardEnabled={true}
            containerStyle={{ maxWidth: '351px', width: '100%' }}
          />
        ))}
      </BaseView>
    </BaseSafeFormView>
  )
}
